import ModelBase from "../../../../../../framework/core/mvvm/model_base";
import { NetMsgTexasholdem } from "../../../../net/net_msg_data_map_texasholdem";
import { TableData } from "../../data/table_data";
import { Texas } from "../../../../net/proto/proto_texasholdem_game";

export class TableModelBase extends ModelBase{

    //牌局数据
    boardData:TableData.BoardData;

    //座位数据座位,不一定在战斗
    seatData:TableData.SeatPlayerData[];

    settingData:TableData.Setting;

    commonData:TableData.commonData;

    //牌局
    Init(){
        this.onInit();
    }
    send_seatAction_request(type:number,seat?:number|null,coin?:number,autoRecharge?:boolean){
        let protoData:Texas.ISeatAction = {
            type:type,
            seat:seat,
            recharge:{
                coin:coin,
                autoRecharge:autoRecharge,
            },
        }
        this.sendMsg(NetMsgTexasholdem.SeatAction,protoData);
    }

    send_playaction_request(decision:number,mount?:number|null){
        let protoData:Texas.IPlayerAction = {
            decision:decision,
            mount:mount,
        };
        this.sendMsg(NetMsgTexasholdem.PlayerAction,protoData);
    }

    send_ReCharge_request(coin:number,charge:boolean){
        let protoData:Texas.IRecharge = {
            coin:coin,
            autoRecharge:charge,
        };
        this.sendMsg(NetMsgTexasholdem.Recharge,protoData);
    }

    findSeatInfoBySeatID(seatID:number):TableData.SeatPlayerData{
        if (!this.seatData) {
            cc.log('seatData 数据为空!');
            return null;
        }
        for (let index = 0; index < this.seatData.length; index++) {
            let data = this.seatData[index];
            if (data) {
                if (data.player_pos === seatID) {
                    return data;
                }
            }
            
        }
        return null;
    }

    //移除
    removeSeatInfo(playerID:number){
        for (let index = 0; index < this.seatData.length; index++) {
            let data = this.seatData[index];
            if (data) {
                if (data.player_id == playerID) {
                    this.seatData.splice(index,1);
                    break;
                }
            }
        }
    }

    pushSeatInfo(data:TableData.SeatPlayerData){
        this.removeSeatInfo(data.player_id);
        this.seatData.push(data);
    }

    findSeatInfo(playerID:number):TableData.SeatPlayerData{
        for (let index = 0; index < this.seatData.length; index++) {
            let data = this.seatData[index];
            if (data) {
                if (data.player_id == playerID) {
                    return data;
                }
            }
            
        }
        return null;
    }
    
    onInit(){};
}
